import {api, ContentType} from '../../api';
import {createMutation} from '../../lib';

const {postContractsCidDocuments} = api.contracts;

export const usePostContractsCidDocuments = createMutation((params: Parameters<typeof postContractsCidDocuments>) => {
  const [cid, query, data, reqParams] = params;
  return postContractsCidDocuments(cid, query, data, {
    ...reqParams,
    type: ContentType.FormData,
  });
});
